// Plantillas HTML predefinidas para el envío de correos desde Admin.
// Cada plantilla devuelve un string HTML con marca SatGo y placeholders
// entre corchetes ([TÍTULO], [CONTENIDO], etc.) que el admin reemplaza
// antes de enviar.

const SATGO_LOGO = 'https://sat-go.com/satgo-banner-bg.png';
const TEAL   = '#00bfa5';
const NAVY   = '#1e3a5f';
const SOFT   = '#E6FAFF';
const BG     = '#f4f4f4';
const TEXT   = '#333333';
const SUBTLE = '#888888';

// Plantilla 1: Aviso / notificación simple
const avisoSimple = () => `<!DOCTYPE html>
<html lang="es">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>SatGo</title>
</head>
<body style="margin:0;padding:0;font-family:Arial,sans-serif;background-color:${BG};">
  <table width="100%" cellpadding="0" cellspacing="0" style="background-color:${BG};padding:20px 0;">
    <tr><td align="center">
      <table width="600" cellpadding="0" cellspacing="0" style="background-color:#ffffff;border-radius:8px;box-shadow:0 2px 4px rgba(0,0,0,0.1);">
        <!-- Header -->
        <tr>
          <td style="padding:40px 40px 30px 40px;text-align:center;background-color:${SOFT};border-radius:8px 8px 0 0;">
            <img src="${SATGO_LOGO}" alt="SatGo" style="max-width:200px;height:auto;">
          </td>
        </tr>

        <!-- Contenido -->
        <tr>
          <td style="padding:40px;">
            <h2 style="color:${NAVY};font-size:24px;margin:0 0 20px 0;font-weight:bold;">[TÍTULO DEL CORREO]</h2>

            <p style="color:${TEXT};font-size:16px;line-height:1.6;margin:0 0 20px 0;">
              Hola,
            </p>

            <p style="color:${TEXT};font-size:16px;line-height:1.6;margin:0 0 20px 0;">
              [Escribe aquí el cuerpo de tu mensaje. Puedes usar varios párrafos para explicar el aviso, novedad o información que quieras compartir con tus usuarios.]
            </p>

            <p style="color:${TEXT};font-size:16px;line-height:1.6;margin:0 0 20px 0;">
              [Párrafo opcional con más detalle.]
            </p>

            <!-- Botón CTA (opcional, eliminar si no se usa) -->
            <table width="100%" cellpadding="0" cellspacing="0" style="margin:30px 0;">
              <tr>
                <td align="center">
                  <a href="https://web.sat-go.com" style="display:inline-block;background-color:${TEAL};color:#ffffff;text-decoration:none;padding:14px 36px;border-radius:6px;font-size:16px;font-weight:bold;">[Texto del botón]</a>
                </td>
              </tr>
            </table>

            <p style="color:${TEXT};font-size:16px;line-height:1.6;margin:30px 0 0 0;">
              ¿Dudas? Escríbenos, estamos para ayudarte.
            </p>

            <p style="color:${TEXT};font-size:16px;line-height:1.6;margin:20px 0 0 0;">
              Saludos,<br>
              <strong>El equipo de SatGo</strong>
            </p>
          </td>
        </tr>

        <!-- Footer -->
        <tr>
          <td style="padding:30px 40px;background-color:#f8f8f8;border-radius:0 0 8px 8px;text-align:center;">
            <p style="color:${SUBTLE};font-size:14px;margin:0 0 8px 0;">© ${new Date().getFullYear()} SatGo. Todos los derechos reservados.</p>
            <p style="color:${SUBTLE};font-size:12px;margin:0;">Recibes este correo porque tienes una cuenta activa en SatGo.</p>
          </td>
        </tr>
      </table>
    </td></tr>
  </table>
</body>
</html>`;

// Plantilla 2: Promoción (basada en promo_declaracion_email_preview.html)
const promocion = () => `<!DOCTYPE html>
<html lang="es">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>SatGo — Promoción</title>
</head>
<body style="margin:0;padding:0;font-family:Arial,sans-serif;background-color:${BG};">
  <table width="100%" cellpadding="0" cellspacing="0" style="background-color:${BG};padding:20px 0;">
    <tr><td align="center">
      <table width="600" cellpadding="0" cellspacing="0" style="background-color:#ffffff;border-radius:8px;box-shadow:0 2px 4px rgba(0,0,0,0.1);">
        <!-- Header con Logo -->
        <tr>
          <td style="padding:40px 40px 30px 40px;text-align:center;background-color:${SOFT};border-radius:8px 8px 0 0;">
            <img src="${SATGO_LOGO}" alt="SatGo" style="max-width:200px;height:auto;">
          </td>
        </tr>

        <!-- Banner de descuento -->
        <tr>
          <td style="padding:0 40px;">
            <table width="100%" cellpadding="0" cellspacing="0" style="background:linear-gradient(135deg,${TEAL} 0%,${NAVY} 100%);border-radius:8px;">
              <tr>
                <td style="padding:30px;text-align:center;">
                  <p style="color:${SOFT};font-size:14px;margin:0 0 8px 0;letter-spacing:2px;text-transform:uppercase;">[Etiqueta de la promo]</p>
                  <h1 style="color:#ffffff;font-size:36px;margin:0 0 8px 0;font-weight:bold;">[XX% de descuento]</h1>
                  <p style="color:${SOFT};font-size:15px;margin:0;">con el código <strong style="background-color:#ffffff;color:${NAVY};padding:4px 12px;border-radius:4px;letter-spacing:1px;">[CÓDIGO]</strong></p>
                </td>
              </tr>
            </table>
          </td>
        </tr>

        <!-- Contenido principal -->
        <tr>
          <td style="padding:40px;">
            <h2 style="color:${NAVY};font-size:24px;margin:0 0 20px 0;font-weight:bold;">[Título atractivo de la promoción]</h2>

            <p style="color:${TEXT};font-size:16px;line-height:1.6;margin:0 0 20px 0;">Hola,</p>

            <p style="color:${TEXT};font-size:16px;line-height:1.6;margin:0 0 20px 0;">
              [Escribe el gancho del mensaje. Habla del contexto y de por qué esta promoción es relevante ahora.]
            </p>

            <!-- Bloque propuesta -->
            <table width="100%" cellpadding="0" cellspacing="0" style="background-color:#f0f9ff;border-left:4px solid ${TEAL};border-radius:4px;margin:25px 0;">
              <tr>
                <td style="padding:25px;">
                  <h3 style="color:${NAVY};font-size:18px;margin:0 0 12px 0;font-weight:bold;">💡 [Subtítulo del bloque]</h3>
                  <p style="color:#555555;font-size:15px;line-height:1.6;margin:0;">[Describe la propuesta de valor con un par de líneas.]</p>
                </td>
              </tr>
            </table>

            <!-- Beneficios -->
            <h3 style="color:${NAVY};font-size:18px;margin:30px 0 15px 0;font-weight:bold;">Con SatGo dejas de:</h3>
            <table width="100%" cellpadding="0" cellspacing="0">
              <tr><td style="padding:8px 0;"><span style="color:${TEAL};font-size:18px;margin-right:10px;">✓</span><span style="color:#555555;font-size:15px;">[Beneficio 1]</span></td></tr>
              <tr><td style="padding:8px 0;"><span style="color:${TEAL};font-size:18px;margin-right:10px;">✓</span><span style="color:#555555;font-size:15px;">[Beneficio 2]</span></td></tr>
              <tr><td style="padding:8px 0;"><span style="color:${TEAL};font-size:18px;margin-right:10px;">✓</span><span style="color:#555555;font-size:15px;">[Beneficio 3]</span></td></tr>
              <tr><td style="padding:8px 0;"><span style="color:${TEAL};font-size:18px;margin-right:10px;">✓</span><span style="color:#555555;font-size:15px;">[Beneficio 4]</span></td></tr>
            </table>

            <!-- Urgencia -->
            <table width="100%" cellpadding="0" cellspacing="0" style="background-color:#fff8e1;border-left:4px solid #f59e0b;border-radius:4px;margin:30px 0;">
              <tr>
                <td style="padding:20px;">
                  <p style="color:${TEXT};font-size:15px;line-height:1.6;margin:0 0 8px 0;"><strong>⏰ El código [CÓDIGO] vence el [FECHA]</strong></p>
                  <p style="color:#555555;font-size:14px;line-height:1.6;margin:0;">[Frase de cierre que refuerza la urgencia.]</p>
                </td>
              </tr>
            </table>

            <!-- CTA -->
            <table width="100%" cellpadding="0" cellspacing="0" style="margin:30px 0;">
              <tr>
                <td align="center">
                  <a href="https://web.sat-go.com/pricing?coupon=[CÓDIGO]" style="display:inline-block;background-color:${TEAL};color:#ffffff;text-decoration:none;padding:16px 44px;border-radius:6px;font-size:17px;font-weight:bold;">Aprovechar la promoción</a>
                </td>
              </tr>
              <tr><td align="center" style="padding-top:12px;"><p style="color:${SUBTLE};font-size:13px;margin:0;">Aplica el código <strong>[CÓDIGO]</strong> al momento de pagar</p></td></tr>
            </table>

            <p style="color:${TEXT};font-size:16px;line-height:1.6;margin:30px 0 0 0;">Saludos,<br><strong>El equipo de SatGo</strong></p>
          </td>
        </tr>

        <!-- Footer -->
        <tr>
          <td style="padding:30px 40px;background-color:#f8f8f8;border-radius:0 0 8px 8px;text-align:center;">
            <p style="color:${SUBTLE};font-size:13px;margin:0 0 10px 0;">[Términos y condiciones de la promoción.]</p>
            <p style="color:${SUBTLE};font-size:14px;margin:10px 0;">© ${new Date().getFullYear()} SatGo. Todos los derechos reservados.</p>
            <p style="color:${SUBTLE};font-size:12px;margin:0;">Recibes este correo porque tienes una cuenta activa en SatGo.</p>
          </td>
        </tr>
      </table>
    </td></tr>
  </table>
</body>
</html>`;

// Plantilla 3: Aceptación de Términos y Condiciones (clickwrap).
// El backend reemplaza {{ENLACE_ACEPTACION}} por el enlace ÚNICO por destinatario
// y {{VERSION}} por la versión vigente al enviar (endpoint enviar-enlace-masivo).
const aceptacionTyc = () => `<!DOCTYPE html>
<html lang="es">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>SatGo — Términos y Condiciones</title>
</head>
<body style="margin:0;padding:0;font-family:Arial,sans-serif;background-color:${BG};">
  <table width="100%" cellpadding="0" cellspacing="0" style="background-color:${BG};padding:20px 0;">
    <tr><td align="center">
      <table width="600" cellpadding="0" cellspacing="0" style="background-color:#ffffff;border-radius:8px;box-shadow:0 2px 4px rgba(0,0,0,0.1);">
        <!-- Header -->
        <tr>
          <td style="padding:40px 40px 30px 40px;text-align:center;background-color:${SOFT};border-radius:8px 8px 0 0;">
            <img src="${SATGO_LOGO}" alt="SatGo" style="max-width:200px;height:auto;">
          </td>
        </tr>

        <!-- Contenido -->
        <tr>
          <td style="padding:40px;">
            <h2 style="color:${NAVY};font-size:24px;margin:0 0 20px 0;font-weight:bold;">Actualización de Términos y Condiciones</h2>

            <p style="color:${TEXT};font-size:16px;line-height:1.6;margin:0 0 20px 0;">Hola,</p>

            <p style="color:${TEXT};font-size:16px;line-height:1.6;margin:0 0 20px 0;">
              Hemos publicado la versión vigente de nuestros Términos y Condiciones (<strong>{{VERSION}}</strong>).
              Para poder seguir usando SatGo es necesario que los revises y los aceptes.
            </p>

            <p style="color:${TEXT};font-size:16px;line-height:1.6;margin:0 0 20px 0;">
              El siguiente enlace es <strong>único para tu cuenta</strong>. No lo compartas.
            </p>

            <!-- CTA: el href se reemplaza por el enlace único por destinatario -->
            <table width="100%" cellpadding="0" cellspacing="0" style="margin:30px 0;">
              <tr>
                <td align="center">
                  <a href="{{ENLACE_ACEPTACION}}" style="display:inline-block;background-color:${TEAL};color:#ffffff;text-decoration:none;padding:14px 36px;border-radius:6px;font-size:16px;font-weight:bold;">Revisar y aceptar los Términos</a>
                </td>
              </tr>
            </table>

            <p style="color:${SUBTLE};font-size:14px;line-height:1.6;margin:20px 0 0 0;">
              Si el botón no funciona, copia y pega este enlace en tu navegador:<br>
              <span style="color:${TEAL};word-break:break-all;">{{ENLACE_ACEPTACION}}</span>
            </p>

            <p style="color:${TEXT};font-size:16px;line-height:1.6;margin:30px 0 0 0;">
              Saludos,<br>
              <strong>El equipo de SatGo</strong>
            </p>
          </td>
        </tr>

        <!-- Footer -->
        <tr>
          <td style="padding:30px 40px;background-color:#f8f8f8;border-radius:0 0 8px 8px;text-align:center;">
            <p style="color:${SUBTLE};font-size:14px;margin:0 0 8px 0;">© ${new Date().getFullYear()} SatGo. Todos los derechos reservados.</p>
            <p style="color:${SUBTLE};font-size:12px;margin:0;">Recibes este correo porque tienes una cuenta activa en SatGo.</p>
          </td>
        </tr>
      </table>
    </td></tr>
  </table>
</body>
</html>`;

const EMAIL_TEMPLATES = [
  { id: 'blank',          label: '(En blanco)',                       build: () => '' },
  { id: 'aviso',          label: 'Aviso SatGo (simple)',              build: avisoSimple },
  { id: 'promo',          label: 'Promoción SatGo',                   build: promocion },
  { id: 'tyc-aceptacion', label: 'Aceptación de Términos y Condiciones', build: aceptacionTyc, tycMode: true, defaultSubject: 'Acepta los Términos y Condiciones de SatGo' },
];

export default EMAIL_TEMPLATES;
